import { render } from "./Container.vue?vue&type=template&id=32bd8513&scoped=true&bindings={\"width\":\"props\",\"height\":\"props\",\"align\":\"props\",\"mt\":\"props\",\"mb\":\"props\",\"ml\":\"props\",\"mr\":\"props\",\"padding\":\"props\",\"background\":\"props\"}"
import script from "./Container.vue?vue&type=script&lang=js"
export * from "./Container.vue?vue&type=script&lang=js"

import "./Container.vue?vue&type=style&index=0&id=32bd8513&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-32bd8513"

export default script